const Rellax = require('rellax');
import { elements } from './elements';

const initParallax = (parallaxElements) => {

	if (document.body.classList.contains('enable-parallax')) {

		parallaxElements.forEach(item => {
			const options = {
				center: item.classList.contains('rellax-center')
			};
			const rellax = new Rellax(item, options);

			setTimeout(() => {
				rellax.refresh();
			}, 100);
		});
	}
}

export { initParallax };
